import * as React from 'react';

// MUI
import { DATA_MANAGER_COLUMNS } from '../resources/constants/DataManagerTableConstants';
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector,GridToolbarExport } from '@mui/x-data-grid';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';

// Custom
import API_CONSTANTS from '../resources/constants/api.json';

export default function DataManager(props) {
    const useEffect = React.useEffect
    const useState = React.useState;
    const theme = useTheme();
    const userInfo = props.userInfo;
    const [rowJson, setRowJson] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [userFormType, setUserFormType] = useState('')
    const [checkIsActive, setCheckIsActive] = useState((userFormType!=='createUser')?selectedRow && selectedRow.is_active===1?true:false:false);
    const [checkAdmin, setCheckAdmin] = useState((userFormType!=='createUser')?selectedRow && selectedRow.admin===1?true:false:false);        
    const [checkCanApprove, setCheckCanApprove] = useState((userFormType!=='createUser')?selectedRow && selectedRow.can_approve===1?true:false:false);
    const [checkCanDeliver, setCheckCanDeliver] = useState((userFormType!=='createUser')?selectedRow && selectedRow.can_deliver===1?true:false:false);
    const [txtUserEmail, setTxtUserEmail] = useState()
    const [fullName, setFullName] = useState('')

    useEffect(()=>{
        fetch(`${API_CONSTANTS.API_ROUTE}/getAllUsers`)
        .then(
            (response)=>{
                response.json().then(data => {
                    setRowJson(data)
                })
            }
        )
    },[])

    useEffect(()=>{
        setCheckIsActive((userFormType!=='createUser') ? selectedRow && selectedRow.is_active===1?true:false:false);
        setCheckAdmin((userFormType!=='createUser') ? selectedRow && selectedRow.admin===1?true:false:false);        
        setCheckCanApprove((userFormType!=='createUser') ? selectedRow && selectedRow.can_approve===1?true:false:false);
        setCheckCanDeliver((userFormType!=='createUser') ? selectedRow && selectedRow.can_deliver===1?true:false:false);
        setTxtUserEmail((userFormType!=='createUser') ? selectedRow ? selectedRow.email : '':'');
        setFullName((userFormType!=='createUser') ? selectedRow && selectedRow.complete_name?selectedRow.complete_name:'':'');
    },[selectedRow])

    const openModal = (modalType, funcArgs)=>{
        setModalOpen(true)
    }

    const openCreateUserModal = ()=>{
        setUserFormType('createUser')
        openModal();
    }

    const openEditUserModal = ()=>{
        setUserFormType('editUser')
        openModal();
    }

    const handleTxtEmail = (event)=>{
        console.log("handleTxtEmail",event.target.value)
        setTxtUserEmail(event.target.value)
    }
    const handleCheckAdmin = (event) =>{        
        console.log("handleCheckAdmin", event.target.checked)              
        setCheckAdmin(event.target.checked);      
    }    
    const handleCheckIsActive = (event) =>{        
        console.log("handleCheckIsActive", event.target.checked)              
        setCheckIsActive(event.target.checked);      
    }
    const handleCheckCanApprove = (event) =>{        
        console.log("handleCheckCanApprove", event.target.checked)              
        setCheckCanApprove(event.target.checked);      
    }
    const handleCheckCanDeliver = (event) =>{        
        console.log("handleCheckCanDeliver", event.target.checked)              
        setCheckCanDeliver(event.target.checked);      
    }
    const handleFulName = (event)=>{
       setFullName(event.target.value)
    }

    function saveUser(){
        let userData = {}
        if(userFormType==='createUser'){
            console.log("creating user");
            userData = {
                email : txtUserEmail,
                is_active : checkIsActive?1:0,
                admin : checkAdmin?1:0,
                can_approve : checkCanApprove?1:0,
                can_deliver : checkCanDeliver?1:0,
                complete_name : fullName
            }

        }else if(userFormType==='editUser'){
            console.log("Editing user", selectedRow);
            userData = {
                email: selectedRow.email,
                is_active : checkIsActive?1:0,
                admin : checkAdmin?1:0,
                can_approve : checkCanApprove?1:0,
                can_deliver : checkCanDeliver?1:0,
                complete_name : fullName
            }
        }
        console.log("user data", userData)

        fetch(`${API_CONSTANTS.API_ROUTE}/updateUsers`,{
            method:"POST",
            headers: { 'Content-Type': 'application/json'},                
            body:JSON.stringify(userData)
        })
        .then(
            (response)=>{
                response.json().then(result => {
                    if (result.result === 'ok'){
                        let newData;
                        if (userFormType==='editUser'){
                            newData = rowJson.map(user => {
                                if (user.id === result.data[0]._id){
                                    user = {
                                        id: selectedRow.id,
                                        ...userData
                                    }
                                }
                                return user
                            })
                            setRowJson(newData);
                        }
                        else {
                            userData.id = result.data[0]._id
                            newData = [...rowJson, userData]
                            setRowJson(newData);
                        }
                    }
                })
            }
        )

        setModalOpen(false)
        setFullName('')
    }

    
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: theme.palette.background.paper,
        border: '2px solid',
        borderColor: theme.palette.divider,
        borderRadius: 2,
        boxShadow: 24,
        margin: "0",
        padding: 15,
        textAlign: "center",
        width: "50%"
    }

    function CustomToolbar() {
        return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector
                slotProps={{ tooltip: { title: 'Change density' } }}
                />
            <Tooltip title='Add new user'>
                <Button variant='text' onClick={openCreateUserModal} startIcon={<PersonAddIcon/>}>Add</Button>
            </Tooltip>            
            <Box sx={{ flexGrow: 1 }} />
            <GridToolbarExport
                slotProps={{
                    tooltip: { title: 'Export data' },
                    button: { variant: 'outlined' },
                }}
            />
        </GridToolbarContainer>
        );
    }   

    function UserForm(){

        return (
            (
                

                <Stack width={"100%"} spacing={5}>
                    {userFormType === 'createUser' ? 
                        <TextField 
                            id="email-address-textarea"
                            label='Email Address' 
                            variant='outlined'
                            onChange={handleTxtEmail}/> : 
                        ''} 
                            <TextField 
                            id="full-name-textarea"
                            label='Full Name' 
                            variant='outlined'
                            value={fullName}
                            onChange={handleFulName}/> 
                    <Stack direction="row" divider={<Divider orientation='vertical' flexItem />}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkIsActive} onChange={handleCheckIsActive} />} label='Is Active' />
                            <FormControlLabel control={<Checkbox checked={checkAdmin} onChange={handleCheckAdmin}  />} label='Admin' />
                            <FormControlLabel control={<Checkbox checked={checkCanApprove} onChange={handleCheckCanApprove}/>} label='Can Approve' />
                            <FormControlLabel control={<Checkbox checked={checkCanDeliver} onChange={handleCheckCanDeliver} />} label='Can Deliver' />
                        </FormGroup>
                        
                    </Stack>
                    <Tooltip title="Save changes">
                        <Button variant='contained' onClick={saveUser}>Save</Button>
                    </Tooltip>
                </Stack>
            ) 
        )
    }

    //user modification should be hidden if not admin
    return (
        <Box sx={{ bgcolor: theme.palette.background.default, height: '85vh', width: '100%' }}>
            <Modal
                open={modalOpen}
                onClose={()=>{setModalOpen(false); setFullName('')}}
                aria-labelledby="otp-modal"
                aria-describedby="modal-for-otp"
            >
                <Box sx={modalStyle}>                    
                    <Typography id='modal-modal-title' variant='h5'>{(selectedRow && userFormType==='editUser') ? selectedRow.email:'Create New User'}</Typography>
                    <Divider variant='middle' sx={{marginBottom:4,}}/>                    
                    {UserForm()}
                </Box>
            </Modal>

            <Box>
                <Typography variant="h6" component='div' sx={{ flexGrow: 1 }}>Data Manager</Typography>
            </Box>

            <Box display={'flex'} flexDirection={'column'} width="100%">
                <DataGrid
                rows={rowJson}
                loading={!rowJson}
                getRowID={(row)=>row.id}
                columns={DATA_MANAGER_COLUMNS(openEditUserModal, setSelectedRow)}
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                    loadingOverlay: {
                    variant: 'linear-progress',
                    noRowsVariant: 'linear-progress',
                    },
                    toolbar: {
                        showQuickFilter: true,
                    },
                }}
                initialState={{
                    pagination: {
                        paginationModel: {
                        pageSize: 10,
                        },
                    },
                    }}
                    pageSizeOptions={[5,10]}
                    sx={(theme) => ({
                        '& .MuiDataGrid-row': {
                            borderBottom: '1px solid',
                            borderColor: theme.palette.divider,
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid',
                            borderColor: theme.palette.divider,
                        },
                        backgroundColor: theme.palette.background.paper,
                    })}
                />
            
            </Box>
        </Box>
    )
}